namespace RecordShield.Models.Enums {
    export enum AllowedDevices {
        All = 1,
        OnlyWindows = 2,
        SingleDeviceAny = 3,
        OnlyAndroid = 4,
        SingleDeviceWindows = 5,
        SingleDeviceAndroid = 6,
        SingleDeviceWindowsLaptop = 7,
        WindowsAndMac = 8,
        OnlyAndroidAndLaptop = 9
    }
    Serenity.Decorators.registerEnum(AllowedDevices, 'RecordShield.Models.Enums.AllowedDevices');
}
